<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import flaggedOrdersView from "@/components/orders/flaggedOrdersView.vue";

export default {
    page: {
        title: "Flagged Orders",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, flaggedOrdersView },
    data() {
        return {
            title: "Flagged Orders",
            items: [{ text: "Orders", active: true }],
        };
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <flaggedOrdersView />
    </Layout>
</template>
